import Udesk from 'Udesk';
import React from 'react';
import PropTypes from 'prop-types';
import config from '../../../../common/config/index';

const MONTHDAYS = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26,
    27, 28, 29, 30,
];

export default class TaskAssessRulesGatherComponent extends React.Component {
    //#region defaultProps
    static defaultProps = {
        monthDays: MONTHDAYS,
        taskId: null,
        fields: [],
        rules: [],
        onChanged: null,
        disabled: false,
    };
    //#endregion

    //#region propTypes
    static propTypes = {
        monthDays: PropTypes.array,
        taskId: PropTypes.any,
        fields: PropTypes.array,
        rules: PropTypes.array,
        onChanged: PropTypes.func,
        disabled: PropTypes.bool,
    };
    //#endregion

    //#region state
    state = {
        baseFilterVisible: false,
        conditionList: [],
        currentRule: {
            assessmentConf: {},
            baseFilter: {
                conditionList: [],
            },
            customJudgeLogic: '',
            judgeStrategy: 1,
        },
        judgeStrategy: Udesk.enums.judgeStrategy.all.id,
        customJudgeLogic: null,
    };
    //#endregion

    static computes = {
        _fields: [
            'props.fields',
            function ({ props, privates, locales }) {
                if (props.fields) {
                    return Udesk.business.fields.buildConditionFields({
                        fields: props.fields,
                    });
                } else {
                    return [];
                }
            },
        ],
        _fieldValueSettings: [
            'props.fields',
            function ({ props, privates, locales }) {
                return config.getFilterComponentSettings();
            },
        ],
    };

    privates = {
        rules: [],
        rulesIndex: 0,
        conditionJsonInfo: [],
        conditionJson: [],
    };

    //#region actions
    actions = {
        onValueChanged(obj, key, e) {
            let value = e;
            if (e.target) {
                value = e.target.value;
            }
            obj[key] = value;
            this.actions.changeRules();
        },

        onStateChanged(key, e) {
            let value = e;
            if (e.target) {
                value = e.target.value;
            }
            this.setState({
                [key]: value,
            });
        },

        changeTime(rule, time) {
            let value = '';
            if (time) {
                value = time.format('HH:mm:ss').toString();
            }
            rule.assessmentConf.executeTime = value;
            this.actions.changeRules();
        },

        addRule() {
            let rules = this.privates.rules;
            let taskId = this.props.taskId;
            let newRule = {
                _id: this.privates.rulesIndex,
                taskId: taskId,
                taskType: 7,
                assessmentConf: initAssessmentConf(),
                baseFilter: initBaseFilter(),
            };
            rules.push(newRule);
            this.privates.rulesIndex += 1;
            this.actions.changeRules();
        },

        deleteRule(index) {
            let rules = this.privates.rules;
            rules.splice(index, 1);
            this.actions.changeRules();
        },

        changeRules() {
            this.actions.update();
            let rules = this.privates.rules;
            this.trigger('onChanged', rules);
        },

        //显示或隐藏弹出框，将该筛选条件重新复制给一个新的数组
        changeBaseFilterVisible(condition) {
            let baseFilterVisible = this.state.baseFilterVisible;

            if (!baseFilterVisible) {
                this.setState({
                    currentRule: condition,
                });
                if (condition && condition.baseFilter && condition.baseFilter.conditionList) {
                    this.setState({
                        conditionList: [].concat(condition.baseFilter.conditionList),
                    });
                }
                if (
                    condition &&
                    condition.baseFilter &&
                    condition.baseFilter.judgeStrategy != null
                ) {
                    this.setState({
                        judgeStrategy: condition.baseFilter.judgeStrategy,
                    });
                }
                if (
                    condition &&
                    condition.baseFilter &&
                    condition.baseFilter.customJudgeLogic != null
                ) {
                    this.setState({
                        customJudgeLogic: condition.baseFilter.customJudgeLogic,
                    });
                }
            }

            this.setState({
                baseFilterVisible: !baseFilterVisible,
            });
        },

        //监听新数组的变化
        conditionListChanged(val) {
            this.setState({
                conditionList: [].concat(val),
            });
        },

        //取消变更，新数组清零，不复制给筛选条件
        cancelConditionListChanged() {
            this.actions.changeBaseFilterVisible();
        },

        //确认变更，新数组赋值给筛选条件
        confirmConditionListChanged() {
            let rule = this.state.currentRule;
            let conditionList = this.state.conditionList;
            let judgeStrategy = this.state.judgeStrategy;
            let customJudgeLogic = this.state.customJudgeLogic;

            if (rule) {
                rule.baseFilter.conditionList = conditionList;
                rule.baseFilter.judgeStrategy = judgeStrategy;
                rule.baseFilter.customJudgeLogic = customJudgeLogic;
            }

            this.actions.changeBaseFilterVisible();
            this.actions.changeRules();
        },

        //高级筛选器
        handleConditionCancel() {
            this.setState({
                baseFilterVisible: false,
            });
        },
        handleConditionApply(conditionList, customJudgeLogic, judgeStrategy) {
            // let { editKey } = this.privates;
            let condition = this.state.currentRule;
            condition.baseFilter.conditionList = conditionList;
            condition.baseFilter.judgeStrategy = judgeStrategy;
            if (judgeStrategy !== 3) {
                condition.baseFilter.customJudgeLogic = '';
            } else {
                condition.baseFilter.customJudgeLogic = customJudgeLogic;
            }
            this.privates.customId = null;
            this.privates.customName = null;
            // this.setState({currentRule: condition});
            this.actions.changeBaseFilterVisible(condition);
            this.actions.changeRules();
        },
        editFilterOhter(condition) {
            this.setState({
                baseFilterVisible: true,
                currentRule: condition,
            });
        },
        fieldsFilterChange(data) {
            let obj = Udesk.enums.fieldOperators;
            let list = [];
            data.forEach((item) => {
                if (item.value) {
                    if (
                        item.field &&
                        item.field.fieldType === 4 &&
                        item.field.optionValueList &&
                        item.field.optionValueList.length > 0
                    ) {
                        let str =
                            item.field.label +
                            ' ' +
                            obj[item.operator].name +
                            ' ' +
                            getOptionValue(item.value, item.field.optionValueList);
                        list = [...list, str];
                    } else if (Array.isArray(item.value)) {
                        let str = '';
                        item.value.forEach((items) => {
                            if (items.agentName) {
                                str += items.agentName + ',';
                            }
                        });
                        list = [
                            ...list,
                            item.field.label +
                                ' ' +
                                obj[item.operator].name +
                                ' ' +
                                str.substring(0, str.length - 1),
                        ];
                    } else if (typeof item.value === 'object') {
                        let str =
                            item.field.label +
                            ' ' +
                            obj[item.operator].name +
                            ' ' +
                            (item.value.agentName ||
                                item.value.agentGroupName ||
                                item.value.tagName ||
                                item.value.realname ||
                                item.value.departmentName ||
                                '');
                        list = [...list, str];
                    } else if (typeof item.value === 'string') {
                        let str =
                            item.field.label + ' ' + obj[item.operator].name + ' ' + item.value;
                        list = [...list, str];
                    } else {
                        let str =
                            item.field.label + ' ' + obj[item.operator].name + ' ' + item.value;
                        list = [...list, str];
                    }
                } else {
                    let str = item.field.label + ' ' + obj[item.operator].name;
                    list = [...list, str];
                }
            });
            return list.map((item, index) => {
                return (
                    <div
                        style={{
                            color: 'rgba(0, 0, 0, 0.65)',
                            marginBottom: index + 1 === list.length ? '0px' : '8px',
                        }}
                    >
                        {index + 1}. {item}
                    </div>
                );
            });
        },
    };
    //#endregion

    //#region Life Cycle
    init() {
        const { props } = this;
        let conditions = [];
        let conditionJsonInfo = [];
        let conditionJson = [];

        if (props.rules && props.rules.length > 0) {
            conditions = props.rules.map((item, index) => {
                if (item.baseFilter == null) {
                    item.baseFilter = initBaseFilter();
                }
                if (item.assignConf == null) {
                    item.assignConf = initAssessmentConf();
                }
                return {
                    _id: index,
                    ...item,
                };
            });
            conditions.forEach((condition) => {
                let res =
                    condition.baseFilter &&
                    condition.baseFilter.conditionList &&
                    condition.baseFilter.conditionList.map((item) => {
                        if (item.field && item.field.statusKey) {
                            return {
                                ...item,
                                field: {
                                    ...item.field,
                                    id: `${item.field.id}-${item.field.inspectionTaskId}`,
                                },
                            };
                        }
                        return item;
                    });
                conditionJsonInfo.push(res);
            });
            conditions.forEach((condition) => {
                let res =
                    condition.baseFilter &&
                    condition.baseFilter.conditionList &&
                    condition.baseFilter.conditionList.map((item) => {
                        if (item.field && item.field.statusKey) {
                            return {
                                field: `${item.field.id}-${item.field.inspectionTaskId}`,
                                operator: item.operator,
                                value: item.value,
                                statusKey: `${item.field.id}-${item.field.inspectionTaskId}`,
                            };
                        }
                        return {
                            field: item.field.id,
                            operator: item.operator,
                            value: item.value,
                        };
                    });
                conditionJson.push(res);
            });
        }
        this.privates.conditionJsonInfo = conditionJsonInfo;
        this.privates.conditionJson = conditionJson;
        this.privates.rulesIndex = props.rules.length;
    }
    componentDidMount() {}
    parseProps({ props, prevProps }) {
        let conditions = [];
        let conditionJsonInfo = [];
        let conditionJson = [];
        if (props.rules && props.rules.length > 0) {
            conditions = props.rules.map((item, index) => {
                if (item.baseFilter == null) {
                    item.baseFilter = initBaseFilter();
                }
                if (item.assessmentConf == null) {
                    item.assessmentConf = initAssessmentConf();
                }
                return {
                    _id: index,
                    ...item,
                };
            });
            conditions.forEach((condition) => {
                let res =
                    condition.baseFilter &&
                    condition.baseFilter.conditionList &&
                    condition.baseFilter.conditionList.map((item) => {
                        if (item.field && item.field.statusKey) {
                            return {
                                ...item,
                                field: {
                                    ...item.field,
                                    id: `${item.field.id}-${item.field.inspectionTaskId}`,
                                },
                            };
                        }
                        return item;
                    });
                conditionJsonInfo.push(res);
            });
            conditions.forEach((condition) => {
                let res =
                    condition.baseFilter &&
                    condition.baseFilter.conditionList &&
                    condition.baseFilter.conditionList.map((item) => {
                        let res = {};
                        if (item.field && item.field.statusKey) {
                            res = {
                                field: `${item.field.id}-${item.field.inspectionTaskId}`,
                                operator: item.operator,
                                value: item.value,
                                statusKey: `${item.field.id}-${item.field.inspectionTaskId}`,
                            };
                        } else {
                            res = {
                                field: item.field.id,
                                operator: item.operator,
                                value: item.value,
                            };
                        }
                        return res;
                    });
                conditionJson.push(res);
            });
        }
        return {
            conditionJsonInfo,
            conditionJson,
            rules: conditions,
            rulesIndex: props.rules ? props.rules.length : 0,
        };
    }
    //#endregion
}

function getOptionValue(id, optionValueList) {
    let value = optionValueList.filter((item) => {
        if (Array.isArray(id)) {
            return id.includes(item.id);
        } else {
            return item.id === id;
        }
    });
    if (value.length > 0) {
        value = value.map((item) => {
            return item.name;
        });
        return value.join(',');
    } else {
        return '';
    }
}

function initAssessmentConf() {
    return {
        assessmentCycle: Udesk.enums.assessFrequencyTypes.everyDay.id,
        dayOfWeek: Udesk.enums.assessFrequencyWeekDays.Monday.id,
        dayOfMonth: 1,
        executeTime: '02:30:00',
        actionType: Udesk.enums.assessActionTypes.reassess.id,
    };
}

function initBaseFilter() {
    return {
        conditionList: [],
        judgeStrategy: Udesk.enums.judgeStrategy.all.id,
        customJudgeLogic: '',
    };
}
